function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function renderJsonTree(value) {
  if (value === null) return '<span class="wc-json-null">null</span>'
  if (value === undefined) return '<span class="wc-json-undefined">undefined</span>'
  if (typeof value === 'string') return '<span class="wc-json-string">"' + escapeHtml(value) + '"</span>'
  if (typeof value === 'number') return '<span class="wc-json-number">' + escapeHtml(String(value)) + '</span>'
  if (typeof value === 'boolean') return '<span class="wc-json-boolean">' + escapeHtml(String(value)) + '</span>'

  if (Array.isArray(value)) {
    if (!value.length) return '<span class="wc-json-punct">[]</span>'
    return '<span class="wc-json-punct">[</span><div class="wc-json-block">' + value.map(function (item, index) {
      return '<div class="wc-json-line"><span class="wc-json-index">' + index + '</span><span class="wc-json-separator">:</span>' + renderJsonTree(item) + '</div>'
    }).join('') + '</div><span class="wc-json-punct">]</span>'
  }

  if (typeof value === 'object') {
    var keys = Object.keys(value)
    if (!keys.length) return '<span class="wc-json-punct">{}</span>'
    return '<span class="wc-json-punct">{</span><div class="wc-json-block">' + keys.map(function (key) {
      return '<div class="wc-json-line"><span class="wc-json-key">"' + escapeHtml(key) + '"</span><span class="wc-json-separator">: </span>' + renderJsonTree(value[key]) + '</div>'
    }).join('') + '</div><span class="wc-json-punct">}</span>'
  }

  return '<span class="wc-json-string">"' + escapeHtml(String(value)) + '"</span>'
}

function renderHistoryConsole(entry, index) {
  var raw = entry
  var label = entry && (entry.role || entry.from || entry.type || 'event')
  var summary = []
  if (entry && entry.skill) summary.push('skill: ' + entry.skill)
  if (entry && entry.step) summary.push('step: ' + entry.step)
  if (entry && entry.ts) summary.push('ts: ' + entry.ts)

  return (
    '<details class="wc-history-console" ' + (index === 0 ? 'open' : '') + '>' +
      '<summary class="wc-history-summary">' +
        '<span class="wc-history-summary-label">' + escapeHtml(label) + '</span>' +
        (summary.length ? '<span class="wc-history-summary-meta">' + escapeHtml(summary.join(' · ')) + '</span>' : '') +
      '</summary>' +
      '<div class="wc-history-console-json">' + renderJsonTree(raw) + '</div>' +
    '</details>'
  )
}

export { renderHistoryConsole }
